import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/app/[locale]/branchen/industries-overview.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/node_modules/next/dist/client/link.js");
